import { z } from "zod"

export const formSchema = z.object({
  trialShiftResult: z.enum(["Passed", "Failed"]),
  requireAnotherTrial: z.boolean(),
  attended: z.boolean(),

  // Delivery Protocol Adherence (40%)
  deliveryProtocolScores: z.object({
    deliveryPictures: z.string(), // 15%
    deliveryNotes: z.string(), // 15%
    instructionCompliance: z.string(), // 10%
  }),

  // Delivery Success Rate (30%)
  deliverySuccessRate: z.string(),

  // Road Safety (14%)
  roadSafetyScores: z.object({
    drivingBehaviour: z.string(), // 7%
    vehicleHandling: z.string(), // 7%
  }),
  // safety_score is a bigint column in the DB. The field is a text input, so we
  // coerce it to a whole number (0–100) at validation time; a blank field is
  // allowed and treated as "no score" (undefined).
  safetyScore: z
    .union([z.string(), z.number(), z.null(), z.undefined()])
    .transform((v) => (v === "" || v === null || v === undefined ? undefined : Number(v)))
    .pipe(
      z
        .number({ error: "Safety score must be a whole number" })
        .int("Safety score must be a whole number")
        .min(0, "Safety score must be between 0 and 100")
        .max(100, "Safety score must be between 0 and 100")
        .optional(),
    ),

  // Customer Interaction & Problem Solving (2%)
  customerInteractionScores: z.object({
    customerFeedback: z.string(), // 1%
    issueResolution: z.string(), // 1%
  }),

  // Time Management (10%)
  timeManagement: z.string(),

  // Load Check - Parcel Preparedness (4%)
  loadCheck: z.string(),

  comments: z.string().optional(),
})

// safetyScore is typed as text and transformed to a number, so the form holds the input type and submits the output.
export type FormInput = z.input<typeof formSchema>
export type FormValues = z.infer<typeof formSchema>

export const defaultFormValues: FormValues = {
  trialShiftResult: "Failed",
  requireAnotherTrial: false,
  attended: false,
  deliveryProtocolScores: {
    deliveryPictures: "",
    deliveryNotes: "",
    instructionCompliance: "",
  },
  deliverySuccessRate: "",
  roadSafetyScores: {
    drivingBehaviour: "",
    vehicleHandling: "",
  },
  safetyScore: undefined,
  customerInteractionScores: {
    customerFeedback: "",
    issueResolution: "",
  },
  timeManagement: "",
  loadCheck: "",
  comments: "",
}
